const accountPopup = () => {
  const handleAccountToggle = event => {
    if (event) {
      event.preventDefault();
    }
    document.body.classList.toggle("account-is-visible");
    if (event.target.classList.contains("pdp-signup")){
      document.querySelector(".side-account-wrapper").classList.add("signup-visible");
    }
  };

  const accountToggle = document.querySelectorAll("[data-toggle-account]");
  if (accountToggle.length > 0) {
    accountToggle.forEach(el =>
      el.addEventListener("click", handleAccountToggle)
    );
  }

  const handleLoginPopup = event => {
    if (event) {
      event.preventDefault();
    }
    const sideAccountWrapper = document.querySelector(".side-account-wrapper");
    sideAccountWrapper && sideAccountWrapper.classList.contains("signup-visible")
      ? sideAccountWrapper.classList.remove("signup-visible")
      : sideAccountWrapper.classList.add("signup-visible");
  };

  const toggleLogin = document.querySelectorAll(
    ".side-account [data-toggle-login]"
  );
  if (toggleLogin.length > 0) {
    toggleLogin.forEach(el => el.addEventListener("click", handleLoginPopup));
  }
};
export default accountPopup;
